import { gql } from '@apollo/client';

export const CANCEL_SUBSCRIPTION_CONTRACT = gql`
  mutation wCancelSubscriptionContract(
    $uid: UUID!
    $cancelCode: String
    $justification: String
  ) {
    wCancelSubscriptionContract(
      uid: $uid
      cancelCode: $cancelCode
      justification: $justification
    )
  }
`;
